import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import CLIENT_ENDPOINTS from '../../constants/client-endpoints'
import useCurrentUser from '../../hooks/use-current-user'

const UsersScreen = () => (<Redirect to={CLIENT_ENDPOINTS.USERS} />)

const ScheduleScreen = () => (<Redirect to={CLIENT_ENDPOINTS.SCHEDULE} />)

const DefaultRoutes = () => {
    const { isAdmin, isStudent } = useCurrentUser()

    if (isAdmin) {
        return (<Route exact path={CLIENT_ENDPOINTS.ROOT} render={() => (<UsersScreen />)} /> )
    }

    if (isStudent) {
        return (<Route exact path={CLIENT_ENDPOINTS.ROOT} render={() => (<ScheduleScreen />)} /> )
    }

    return null
}


export default DefaultRoutes